export default [
  { path: '/user/info', name: 'UserInfo', component: () => import(/* webpackChunkName: "user-info" */ './index.vue') }
]